import styled, { keyframes } from 'styled-components'

const gradientAnimation = keyframes`
  0% {
    background: 
    linear-gradient(180deg, rgba(255, 255, 255, 0.00) 71.9%, #FFF 87.32%, #FFF 100%),
    radial-gradient(90.85% 145.34% at 50% 50%, 
      #FFF 0%, #FFF 30%, #F9E5E9 40%, #E6E4EF 50%, #FBFEE7 60%, #FFF 100%);
  }
  10% {
    background:     
    linear-gradient(180deg, rgba(255, 255, 255, 0.00) 71.9%, #FFF 87.32%, #FFF 100%),
    radial-gradient(90.85% 145.34% at 50% 50%, 
      #FFF 0%, #FFF 30%, #F8E8EC 40%, #E5E5F0 50%, #FAFDE5 60%, #FFF 100%);
  }
  20% {
    background:     
    linear-gradient(180deg, rgba(255, 255, 255, 0.00) 71.9%, #FFF 87.32%, #FFF 100%),
    radial-gradient(90.85% 145.34% at 50% 50%, 
      #FFF 0%, #FFF 30%, #F7EBEF 40%, #E4E6F1 50%, #F9FCE3 60%, #FFF 100%);
  }
  30% {
    background:     
    linear-gradient(180deg, rgba(255, 255, 255, 0.00) 71.9%, #FFF 87.32%, #FFF 100%),
    radial-gradient(90.85% 145.34% at 50% 50%, 
      #FFF 0%, #FFF 30%, #F6EEF2 40%, #E3E7F2 50%, #F8FBE1 60%, #FFF 100%);
  }
  40% {
    background:     
    linear-gradient(180deg, rgba(255, 255, 255, 0.00) 71.9%, #FFF 87.32%, #FFF 100%),
    radial-gradient(90.85% 145.34% at 50% 50%, 
      #FFF 0%, #FFF 30%, #F5F1F5 40%, #E2E8F3 50%, #F7FAE0 60%, #FFF 100%);
  }
  50% {
    background:     
    linear-gradient(180deg, rgba(255, 255, 255, 0.00) 71.9%, #FFF 87.32%, #FFF 100%),
    radial-gradient(90.85% 145.34% at 50% 50%, 
      #FFF 0%, #FFF 30%, #F4F4F8 40%, #E1E9F4 50%, #F6F9DF 60%, #FFF 100%);
  }
  60% {
    background:     
    linear-gradient(180deg, rgba(255, 255, 255, 0.00) 71.9%, #FFF 87.32%, #FFF 100%),
    radial-gradient(90.85% 145.34% at 50% 50%, 
      #FFF 0%, #FFF 30%, #F5F1F5 40%, #E2E8F3 50%, #F7FAE0 60%, #FFF 100%);
  }
  70% {
    background:     
    linear-gradient(180deg, rgba(255, 255, 255, 0.00) 71.9%, #FFF 87.32%, #FFF 100%),
    radial-gradient(90.85% 145.34% at 50% 50%, 
      #FFF 0%, #FFF 30%, #F6EEF2 40%, #E3E7F2 50%, #F8FBE1 60%, #FFF 100%);
  }
  80% {
    background:     
    linear-gradient(180deg, rgba(255, 255, 255, 0.00) 71.9%, #FFF 87.32%, #FFF 100%),
    radial-gradient(90.85% 145.34% at 50% 50%, 
      #FFF 0%, #FFF 30%, #F7EBEF 40%, #E4E6F1 50%, #F9FCE3 60%, #FFF 100%);
  }
  90% {
    background:    
    linear-gradient(180deg, rgba(255, 255, 255, 0.00) 71.9%, #FFF 87.32%, #FFF 100%),
    radial-gradient(90.85% 145.34% at 50% 50%,
      #FFF 0%, #FFF 30%, #F8E8EC 40%, #E5E5F0 50%, #FAFDE5 60%, #FFF 100%);
  }
  100% {
    background:     
    linear-gradient(180deg, rgba(255, 255, 255, 0.00) 71.9%, #FFF 87.32%, #FFF 100%),
    radial-gradient(90.85% 145.34% at 50% 50%, 
      #FFF 0%, #FFF 30%, #F9E5E9 40%, #E6E4EF 50%, #FBFEE7 60%, #FFF 100%);
  }
`

const GradientSection = styled.section`
  background: radial-gradient(
    90.85% 145.34% at 50% 50%,
    #fff 0%,
    #fff 30%,
    #f9e5e9 40%,
    #e6e4ef 50%,
    #fbfee7 60%,
    #fff 100%
  );
  animation: ${gradientAnimation} 3s ease-in-out infinite;
`

export default GradientSection
